import { resolveMigrationUrl } from "./brands";
import { currentBrand } from "./index";

/**
 * Migration des utilisateurs du domaine historique diagnosticrapid.fr vers
 * inspexio.com. Tout ce fichier est voué à disparaître avec l'ancien domaine.
 */

/**
 * Date après laquelle diagnosticrapid.fr ne sera plus servi, au format ISO
 * (« 2027-01-31 »). Tant qu'elle vaut `null`, le bandeau et la modale
 * n'annoncent aucune échéance.
 */
export const LEGACY_DOMAIN_DEADLINE: string | null = null;

/** L'utilisateur est encore sur l'ancienne application : on l'invite à migrer. */
export const isLegacyBrand: boolean = currentBrand.id === "dr";

/** Adresse de la nouvelle application, pour le bouton de redirection. */
export const migrationUrl: string = resolveMigrationUrl(
  window.location.hostname,
);

/** L'échéance en toutes lettres dans la langue donnée, ou `null` si non fixée. */
export function formatMigrationDeadline(language: string): string | null {
  if (!LEGACY_DOMAIN_DEADLINE) return null;
  return new Date(LEGACY_DOMAIN_DEADLINE).toLocaleDateString(language, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

/**
 * Faut-il faire copier l'adresse plutôt que l'ouvrir ? Oui dès que l'ancienne
 * application est installée (PWA), quel que soit l'appareil : un lien ouvert
 * depuis une PWA reste dans une vue intégrée (iOS, Android) ou peut être
 * capté par une autre PWA (ordinateur), d'où l'on n'installe pas la nouvelle.
 * L'utilisateur colle donc l'adresse lui-même dans son navigateur.
 */
export function mustCopyMigrationUrl(): boolean {
  return (
    window.matchMedia?.("(display-mode: standalone)").matches ||
    // iOS : application lancée depuis l'écran d'accueil.
    (window.navigator as unknown as { standalone?: boolean }).standalone ===
      true
  );
}

/**
 * Ouvre la nouvelle application dans un nouvel onglet — réservé au navigateur
 * (application non installée). L'ancienne reste ouverte, de quoi finir une
 * synchronisation.
 */
export function openMigrationUrl(): void {
  window.open(migrationUrl, "_blank", "noopener");
}
